/** Espelho de App/utils/YoutubeUrl.ts na API, para a prévia do formulário. */
const YOUTUBE_VIDEO_ID = /^[a-zA-Z0-9_-]{11}$/

export function extractYoutubeVideoId(input: string): string | null {
	const value = input?.trim()

	if (!value) {
		return null
	}

	if (YOUTUBE_VIDEO_ID.test(value)) {
		return value
	}

	let url: URL

	try {
		url = new URL(value.startsWith('http') ? value : `https://${value}`)
	} catch {
		return null
	}

	const host = url.hostname.replace(/^www\./, '').toLowerCase()

	if (host === 'youtu.be') {
		const [id] = url.pathname.split('/').filter(Boolean)

		return id && YOUTUBE_VIDEO_ID.test(id) ? id : null
	}

	if (
		host !== 'youtube.com' &&
		host !== 'm.youtube.com' &&
		host !== 'youtube-nocookie.com'
	) {
		return null
	}

	const queryId = url.searchParams.get('v')

	if (queryId && YOUTUBE_VIDEO_ID.test(queryId)) {
		return queryId
	}

	const segments = url.pathname.split('/').filter(Boolean)

	if (
		segments.length >= 2 &&
		['embed', 'shorts', 'live', 'v'].includes(segments[0])
	) {
		return YOUTUBE_VIDEO_ID.test(segments[1]) ? segments[1] : null
	}

	return null
}
